import {DataSubformValidator} from "../DataSubformValidator";
import {LabelsTreeDataDto} from "../../../../service/HierarchyTreeDataDto";
import {CommonTranslationKey} from "../../../../../CommonTranslationKey";
import {ValidationResult} from "../../../../../../../../common/validation/ValidationResult";

export class LabelsSubformValidator implements DataSubformValidator {
    validate(data: LabelsTreeDataDto): ValidationResult {
        const errors = [];

        if (data.labels == null || data.labels.length === 0) {
            errors.push({ errorMessage: CommonTranslationKey.FILL_OUT_AT_LEAST_ONE });
        }

        return {
            errors: errors
        };
    }
}
